module.exports = wp["date"];